import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Injector,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import {
    IDocumentListingItem,
    WidgetViewContentDocumentListingBase,
} from '@fi-shared/widget/document-listing/document-listing-base';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { WidgetContentService } from '../../widget-content.service';
import { fiDebounce } from '@fi-shared/utils/debounce';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { takeUntil } from 'rxjs/operators';
import { FiAppSettings } from '@fi-shared/fi-app-settings';

@Component({
    selector: 'fi-widget-content-document-listing',
    templateUrl: '../../../../../Source/app/shared/widget/document-listing/document-listing.component.html',
    styleUrls: ['./document-listing.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-widget-content-document-listing' },
    standalone: false,
})
export class WidgetContentDocumentListingComponent
    extends WidgetViewContentDocumentListingBase
    implements OnInit, OnDestroy
{
    @Input() languageId: number;
    private reloadDebounce = fiDebounce(() => this.reloadContent(), 2000);

    constructor(
        protected widgetContentService: WidgetContentService,
        private stateService: FiStateService,
        injector: Injector,
        private cdr: ChangeDetectorRef,
    ) {
        super(injector);
    }

    ngOnInit() {
        // load data after CcmSettingsData.StartDelay and then on settings changed with 3 sec debouncing
        setTimeout(() => {
            this.loadData();
        }, FiAppSettings.StartDelay);

        this.widgetSharedService
            .getWidgetSettingsChanged$(() => this.control.Settings)
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe((data) => {
                if (!data || !data.skipReloadData) {
                    this.reloadDebounce();
                }
                this.cdr.markForCheck();
            });
    }

    getItemHref(item: IDocumentListingItem) {
        switch (item.ObjectType) {
            case ObjectTypes.Document:
                return this.stateService.href(FiStateNames.Document.View, { Id: item.ObjectId });
            default:
                throw 'FI: Unexpected ObjectType "' + item.ObjectType + '" WidgetDocumentListingComponent::getItemHref';
        }
    }

    getHeaderTitle() {
        return this.widgetContentService.GetHeaderTitle(this.control, this.languageId);
    }

    reloadContent() {
        this.Data = [];
        this.lastLoaded = false;
        this.loadData();
    }
}
